import { writable } from 'svelte/store';
export const wikiCategoryId = writable(0);
